module.exports = __webpack_public_path__ + "img/chivas-bg-mobile.88a32568.png";